import { render, staticRenderFns } from "./AskQuestionForm.vue?vue&type=template&id=14c802e8&scoped=true&"
import script from "./AskQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AskQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./AskQuestionForm.vue?vue&type=style&index=0&id=14c802e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c802e8",
  null
  
)

export default component.exports